import { OrderIdentifierColumnType } from "@api/graphql/generated/generated-types";
import { resolveOrderIdentifier } from "@src/shipments/utils/orderIdentifierColumn";

// Only include minimal data because different queries return different data,
// so we should define only what we need for maximal compatibility.
type ShipmentData = {
  trackingNumber?: string | null;
  order: {
    name?: string | null | undefined;
    displayId: number;
  };
  shipmentTemplate?:
    | {
        order: {
          name?: string | null | undefined;
        };
      }
    | null
    | undefined;
};

type ShipmentTemplateData = {
  order: {
    name?: string | null | undefined;
    displayId: number;
  };
};

type OrderData = {
  name?: string | null | undefined;
  displayId: number;
  shipment?:
    | ({
        shipmentTemplate?:
          | {
              order: {
                name?: string | null | undefined;
              };
            }
          | null
          | undefined;
      } & Record<string, unknown>) // Allow other properties from Apollo
    | null
    | undefined;
};

export const getShipmentName = (
  shipment: ShipmentData | null | undefined,
  orderIdentifierColumnType: OrderIdentifierColumnType = OrderIdentifierColumnType.OrderId
) => {
  if (!shipment) {
    return "Unnamed Order";
  }
  if (shipment.order.name) {
    return shipment.order.name;
  }
  if (shipment.shipmentTemplate?.order.name) {
    return shipment.shipmentTemplate.order.name;
  }
  return (
    "Order #" +
    resolveOrderIdentifier(
      {
        trackingNumber: shipment.trackingNumber,
        displayId: shipment.order.displayId,
      },
      orderIdentifierColumnType
    )
  );
};

export const getShipmentTemplateName = (
  shipmentTemplate: ShipmentTemplateData | null | undefined
) => {
  if (!shipmentTemplate) {
    return "Unnamed Recurring Order";
  }
  if (shipmentTemplate.order.name) {
    return shipmentTemplate.order.name;
  }
  return "Recurring Order #" + shipmentTemplate.order.displayId;
};

export const getOrderName = (order: OrderData | null | undefined) => {
  if (!order) {
    return "Unnamed Order";
  }
  if (order.name) {
    return order.name;
  }
  if (order.shipment?.shipmentTemplate?.order.name) {
    return order.shipment.shipmentTemplate.order.name;
  }
  return "Order #" + order.displayId;
};
